import React from "react";

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width="25px"
    height="25px"
  >
    <path
      fill="#fff"
      d="M44,24c0,11.044-8.956,20-20,20S4,35.044,4,24S12.956,4,24,4S44,12.956,44,24z"
    />
    <path
      fill="#6a1b9a"
      d="M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z M12.856,35.144c-3-3-4.571-7-4.571-10.856	l15.571,15.427C19.856,39.571,15.856,38.143,12.856,35.144L12.856,35.144z M27.427,39.288L8.714,20.571	c1.571-7,7.857-12.286,15.286-12.286c5.286,0,9.856,2.571,12.714,6.429l-2.144,1.856c-2.427-3.285-6.285-5.427-10.571-5.427	c-5.571,0-10.286,3.571-12.144,8.571l16.429,16.429c4.144-1.429,7.286-5,8.286-9.286h-6.856V24h10	c0,7.429-5.286,13.714-12.286,15.286L27.427,39.288z"
    />
  </svg>
);
